import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { oauthLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;  // StrictMode-safe one-time exchange
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        oauthLogin(data.token, data.user);
        toast.success(`Welcome, ${data.user.name}.`);
        nav("/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen hero-grain flex items-center justify-center text-neutral-400">
      Signing you in…
    </div>
  );
}
